import { StepName } from '@store/step-forms/step.interface';

export type Scripts = Record<ScriptType, Script>;

export type ScriptType = HeaderScriptType | StepScriptType;

export const enum HeaderScriptType {
  AllPagesHeader = 'allpagesheader'
}

export const enum StepScriptType {
  Tickets = 'tickets',
  Workshop = 'workshop',
  Menu = 'menu',
  Personal = 'personal',
  Legitimation = 'legitimation',
  Confirmation = 'confirmation',
  Invoice = 'invoice'
}

export type Script = string;

export const enum ScriptInjectId {
  OperatorsScript = 'operators-script',
  EventStepScript = 'event-step-script',
  EventAllPagesScript = 'event-all-pages-script'
}

export const StepNameToScriptType: Partial<Record<StepName, StepScriptType>> = {
  [StepName.Tickets]: StepScriptType.Tickets,
  [StepName.BuyerInformation]: StepScriptType.Personal,
  [StepName.BuyerQuestionnaire]: undefined,
  [StepName.TicketAssignment]: undefined,
  [StepName.Legitimation]: StepScriptType.Legitimation,
  [StepName.Workshop]: StepScriptType.Workshop,
  [StepName.Menu]: StepScriptType.Menu,
  [StepName.Confirmation]: StepScriptType.Confirmation,
  [StepName.Invoice]: StepScriptType.Invoice
};

export type InjectableScripts = InjectableScript[];

export interface InjectableScript {
  id: ScriptId;
  src: string;
  innerHtml: string;
  target: ScriptInjectionTarget;
}

export type ScriptId = `${ScriptInjectId}` | `${ScriptInjectId}-${string}`;

export const enum ScriptInjectionTarget {
  Head = 'head',
  Body = 'body'
}
